import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ApiEndpointsService } from "./shared/services/api-endpoints.service";
import { ApiHttpService } from "./shared/services/api-http.service";
import { ConfigService } from "./shared/services/base-service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "pc-portal";
  selectedCompany: any;
  menuItems: any = [];
  selectedMenuItem: any;
  compalyList: any;
  companies: any;

  constructor(
    private router: Router,
    private apiHttpService: ApiHttpService,
    private apiEndpointsService: ApiEndpointsService,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.companies = this.configService.baseData;
    if (this.configService.baseData) {
      this.selectedCompany = this.companies[0];
      this.getAllMenuItems(this.selectedCompany.id);
    }
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  handleCompanyChange(company: any) {
    this.selectedCompany = company.value;
    this.getAllMenuItems(this.selectedCompany.id);
  }

  handleMenuItemChange(item: any) {
    this.selectedMenuItem = item;
    this.router.navigate(
      [
        `${this.selectedCompany.id}/${this.selectedMenuItem.type}/${this.selectedMenuItem.id}`,
      ],
      { state: { ...this.selectedMenuItem } }
    );
  }

  getAllMenuItems(companyId: string) {
    this.apiHttpService
      .get(this.apiEndpointsService.getMenuItems(companyId))
      .subscribe(
        (response) => {
          let menuItemsResponse = JSON.parse(JSON.stringify(response));
          this.menuItems = menuItemsResponse.data;
          this.selectedMenuItem = this.menuItems[0];
          this.router.navigate(
            [
              `${this.selectedCompany.id}/${this.selectedMenuItem.type}/${this.selectedMenuItem.id}`,
            ],
            { state: { ...this.selectedMenuItem } }
          );
        },
        (error) => {
          console.log("Error: ", error);
        }
      );
  }
  getAllCompanyList() {
    this.apiHttpService.get(this.apiEndpointsService.getBaseData()).subscribe(
      (response) => {
        let baseData = JSON.parse(JSON.stringify(response));
        this.companies = baseData.data;
        this.selectedCompany = this.companies[0];
      },
      (error) => {
        console.log("Error:", error);
      }
    );
  }
}
